import FalconImage from '../../../../assets/images/logo-photos/falcon-logo.jpg'; // Placeholder image

export const rawEmployees = [
  {
    "name": "Mr. Angelo Garcia",
    "title": "Founder/Executive Director",
    "department": "Executive Leadership"
  },
  {
    "name": "Dr. Melissa Lourenco",
    "title": "Founder/District Administrator",
    "department": "Executive Leadership"
  },
  {
    "name": "Mr. Kevin Montoya",
    "title": "Davis REACH Academy Principal",
    "department": "Executive Leadership"
  },
  {
    "name": "Mrs. Michelle Laboissionniere",
    "title": "Principal Apprentice",
    "department": "Executive Leadership"
  },
  {
    "name": "Mr. Joseph Mitchell",
    "title": "Principal",
    "department": "Executive Leadership"
  },
  {
    "name": "Mrs. Jenny Sousa",
    "title": "Central Office Coor",
    "department": "District Support"
  },
  {
    "name": "Mrs. Dorothy Rivera-Perez",
    "title": "HR/Payroll",
    "department": "District Support"
  },
  {
    "name": "Ms. Maybi Cante",
    "title": "Purchasing Agent",
    "department": "District Support"
  },
  {
    "name": "Mrs. Ann Manocchio",
    "title": "Finance Consultant",
    "department": "District Support"
  },
  {
    "name": "Mr. Joshua Laboissonniere",
    "title": "Dir. Facilities & School Safety",
    "department": "Facilities"
  },
  {
    "name": "Mr. Richard Seaman",
    "title": "Maintenance",
    "department": "Facilities"
  },
  {
    "name": "Mr. Anthony Olivera",
    "title": "Maintenance",
    "department": "Facilities"
  },
  {
    "name": "Mr. Adam Manocchio",
    "title": "Maintenance",
    "department": "Facilities"
  },
  {
    "name": "Mr. Miguel Caldero",
    "title": "Custodian - Davis REACH Academy",
    "department": "Facilities"
  },
  {
    "name": "Mrs. Ada Giron",
    "title": "Custodian - Legacy",
    "department": "Facilities"
  },
  {
    "name": "Mr. Raphael Montes",
    "title": "Van Driver",
    "department": "Facilities"
  },
  {
    "name": "Mr. Angel Mendez",
    "title": "Director of Technology",
    "department": "Technology"
  },
  {
    "name": "Mr. Janlouis Amadis",
    "title": "Asst. Director of Technology",
    "department": "Technology"
  },
  {
    "name": "Mr. Elvis Huertas",
    "title": "IT Support - Legacy",
    "department": "Technology"
  },
  {
    "name": "Mr. Matthew Moreno",
    "title": "IT Support - Davis REACH Academy",
    "department": "Technology"
  },
  {
    "name": "Mrs. Nadya Sanchez",
    "title": "Family Engagement Coor.",
    "department": "Family Engagement"
  },
  {
    "name": "Mrs. Maria Porras",
    "title": "Food Pantry",
    "department": "Family Engagement"
  },
  {
    "name": "Mr. John Sharrott",
    "title": "Director of Special Education",
    "department": "Student Support"
  },
  {
    "name": "Mr. Kestler Rodriguez",
    "title": "Director of After School Programs",
    "department": "After School Programming"
  },
  {
    "name": "Mr. Jonah Vinas",
    "title": "Asst. Dir. After School",
    "department": "After School Programming"
  },
  {
    "name": "Mrs. Celeste de la Roca",
    "title": "Office Support Staff",
    "department": "Main Office"
  },
  {
    "name": "Ms. Jocelyn Pedroza",
    "title": "Office Support Staff",
    "department": "Main Office"
  },
  {
    "name": "Mrs. Chloe Allen",
    "title": "K Teacher",
    "department": "K-2 Teachers"
  },
  {
    "name": "Ms. Carolina Veras",
    "title": "K Teacher",
    "department": "K-2 Teachers"
  },
  {
    "name": "Ms. Caroline Williams",
    "title": "1 Teacher",
    "department": "K-2 Teachers"
  },
  {
    "name": "Ms. Gabrielle Milley",
    "title": "1 Teacher",
    "department": "K-2 Teachers"
  },
  {
    "name": "Mrs. Kaholanis Amadis",
    "title": "2 Teacher",
    "department": "K-2 Teachers"
  },
  {
    "name": "Mr. Daniel Lipson",
    "title": "2 Teacher",
    "department": "K-2 Teachers"
  },
  {
    "name": "Ms. Kelssy Barrios",
    "title": "K Fellow",
    "department": "K-2 Teaching Fellows"
  },
  {
    "name": "Ms. Sophia Calise",
    "title": "K Fellow",
    "department": "K-2 Teaching Fellows"
  },
  {
    "name": "Ms. Paula Guidales",
    "title": "1 Fellow",
    "department": "K-2 Teaching Fellows"
  },
  {
    "name": "Ms. Kaholanis Amadis",
    "title": "1 Fellow",
    "department": "K-2 Teaching Fellows"
  },
  {
    "name": "Ms. Mara Lugo",
    "title": "2 Fellow",
    "department": "K-2 Teaching Fellows"
  },
  {
    "name": "Mr. Bruce Crespo",
    "title": "3rd Grade Teacher",
    "department": "3-5 Teachers"
  },
  {
    "name": "Ms. Savannah Lee",
    "title": "3rd Grade Teacher",
    "department": "3-5 Teachers"
  },
  {
    "name": "Mrs. Natasha Perez-Weeks",
    "title": "4 Teacher",
    "department": "3-5 Teachers"
  },
  {
    "name": "Ms. Julia Vanelli",
    "title": "4 Teacher",
    "department": "3-5 Teachers"
  },
  {
    "name": "Ms. Nicole Fochler",
    "title": "5 Teacher",
    "department": "3-5 Teachers"
  },
  {
    "name": "Ms. Isabel Kelly",
    "title": "5 Teacher",
    "department": "3-5 Teachers"
  },
  {
    "name": "Mr. Brian Coleman",
    "title": "3-5 Fellow",
    "department": "3-5 Teaching Fellows"
  },
  {
    "name": "Mr. Bruce Crespo",
    "title": "1:1 Support",
    "department": "3-5 Teaching Fellows"
  },
  {
    "name": "Mr. Alex Fung",
    "title": "3 Fellow",
    "department": "3-5 Teaching Fellows"
  },
  {
    "name": "Mr. Yusef Abdullah",
    "title": "4 Fellow",
    "department": "3-5 Teaching Fellows"
  },
  {
    "name": "Ms. Jessy Noguera",
    "title": "5 Fellow",
    "department": "3-5 Teaching Fellows"
  },
  {
    "name": "Mr. James Daly",
    "title": "ELA & Science",
    "department": "Middle School Teachers"
  },
  {
    "name": "Ms. Shannon Sullivan",
    "title": "ELA",
    "department": "Middle School Teachers"
  },
  {
    "name": "Ms. Emily Plummer",
    "title": "Math",
    "department": "Middle School Teachers"
  },
  {
    "name": "Mr. Deion Haughton",
    "title": "Math (8th)",
    "department": "Middle School Teachers"
  },
  {
    "name": "Mr. Jason Sitt",
    "title": "Science",
    "department": "Middle School Teachers"
  },
  {
    "name": "Ms. Stella Schaefer-Surdez",
    "title": "HUM",
    "department": "Middle School Teachers"
  },
  {
    "name": "Mr. John Rosenbaum",
    "title": "HUM",
    "department": "Middle School Teachers"
  },
  {
    "name": "Ms. Valerine Biascochea",
    "title": "K-5 Fitness",
    "department": "MAGNET Team"
  },
  {
    "name": "Mr. Tyler Moniz",
    "title": "K-5 Music",
    "department": "MAGNET Team"
  },
  {
    "name": "Ms. Kendrah Dejesus",
    "title": "K-5 SEL",
    "department": "MAGNET Team"
  },
  {
    "name": "Mrs. Margarita Cardona",
    "title": "K-5 World Language",
    "department": "MAGNET Team"
  },
  {
    "name": "Mr. Jaime Solorzano",
    "title": "6-10 Fitness",
    "department": "MAGNET Team"
  },
  {
    "name": "Mr. Jose Lantigua",
    "title": "6-10 Music",
    "department": "MAGNET Team"
  },
  {
    "name": "Ms. Natalie Grondin",
    "title": "6-10 Art",
    "department": "MAGNET Team"
  },
  {
    "name": "Ms. Talia Autiello",
    "title": "6-10 PE/Health",
    "department": "MAGNET Team"
  },
  {
    "name": "Ms. Yenifer Urizar",
    "title": "6-10 World Language",
    "department": "MAGNET Team"
  },
  {
    "name": "Ms. Julia Dudek",
    "title": "K-2 Special Educator",
    "department": "Individual Needs / Special Ed."
  },
  {
    "name": "Ms. Natalia Molina",
    "title": "K-2 Special Educator",
    "department": "Individual Needs / Special Ed."
  },
  {
    "name": "Ms. Samantha Hillery",
    "title": "6-8 Special Educator",
    "department": "Individual Needs / Special Ed."
  },
  {
    "name": "Ms. Olivia Williams",
    "title": "Speech Language Pathologist",
    "department": "Individual Needs / Special Ed."
  },
  {
    "name": "Mrs. Jackie Casey",
    "title": "Coordinator of Academic Supports",
    "department": "Academic Coaches"
  },
  {
    "name": "Mrs. Arissa DiFillippo",
    "title": "Coordinator of Instructional Coaching",
    "department": "Academic Coaches"
  },
  {
    "name": "Ms. Carly Oguschewitz",
    "title": "MLL Specialist",
    "department": "Academic Coaches"
  },
  {
    "name": "Mrs. Edith Ospina",
    "title": "Reading Specialist",
    "department": "Academic Coaches"
  },
  {
    "name": "Ms. Stephanie Leon",
    "title": "Special Educator/Math Intervention",
    "department": "Academic Coaches"
  },
  {
    "name": "Mrs. Marisol Mendez",
    "title": "Academic Support",
    "department": "Academic Coaches"
  },
  {
    "name": "Ms. Luisa Vasquez",
    "title": "School Social Worker",
    "department": "Counseling & Support"
  },
  {
    "name": "Ms. Christine Wood",
    "title": "School Nurse",
    "department": "Counseling & Support"
  },
  {
    "name": "Ms. Michelle Roman",
    "title": "Nursing Assistant",
    "department": "Counseling & Support"
  },
  {
    "name": "Mrs. Annisbel Zeine",
    "title": "School Social Worker",
    "department": "Counseling & Support"
  },
  {
    "name": "Ms. Madisen Cardona",
    "title": "Behavior Specialist",
    "department": "Deans & Behavior Support"
  },
  {
    "name": "Ms. Katherine McPhillips",
    "title": "Dean of Student Life (Middle School)",
    "department": "Deans & Behavior Support"
  },
  {
    "name": "Mr. Alberto Cardona",
    "title": "Behavior Specialist/Lead",
    "department": "Deans & Behavior Support"
  },
  {
    "name": "Mrs. Ana Soares",
    "title": "Dean of Student Life",
    "department": "Deans & Behavior Support"
  },
  {
    "name": "Ms. Rainha Soares",
    "title": "Dean of Student",
    "department": "Deans & Behavior Support"
  }
];

export const employees = rawEmployees.map(emp => ({
  ...emp,
  photo: FalconImage,
}));
